module.exports = __webpack_public_path__ + "static/bg-51a6cfd88a436c7a4f708d49c6748522.png";